// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/core-js/modules/es6.reflect.own-keys.js
// module id = ../../../../core-js/modules/es6.reflect.own-keys.js
// module chunks = 2